import { oembed } from "@loomhq/loom-embed"

/**
 * Regex to match Loom share URLs.
 * Example: https://www.loom.com/share/VIDEO_ID
 */
export const LOOM_REGEX = /(?:https?:\/\/)?(?:www\.)?loom\.com\/share\/([a-zA-Z0-9]+)/
export const LOOM_REGEX_GLOBAL = /(?:https?:\/\/)?(?:www\.)?loom\.com\/share\/([a-zA-Z0-9]+)/g

/**
 * Checks if a URL is a valid Loom share URL.
 * @param url - The URL to validate.
 * @returns True if valid, false otherwise.
 */
export function isValidLoomUrl(url: string): boolean {
    return LOOM_REGEX.test(url)
}

/**
 * Type for Loom oEmbed data.
 */
export interface LoomOEmbedData {
    type: "video"
    html: string
    title: string
    height: number | null
    width: number | null
    provider_name: "Loom"
    provider_url: string
    thumbnail_height: number
    thumbnail_width: number
    thumbnail_url: string
    duration: number
}

/**
 * Fetches oEmbed data for a Loom video using the SDK.
 * @param url - The Loom share URL.
 * @returns Promise resolving to LoomOEmbedData.
 */
export async function getLoomOEmbedData(url: string): Promise<LoomOEmbedData> {
    if (!isValidLoomUrl(url)) {
        throw new Error("Invalid Loom URL")
    }
    return oembed(url) as Promise<LoomOEmbedData>
}
